(function () {
  var overlay = document.getElementById('newsletter-popup-overlay');
  if (!overlay) return;

  var COOKIE_NAME = 'newsletter_popup_dismissed';
  var DISMISS_DAYS = 7;
  var SCROLL_TRIGGER_PERCENT = 0.3;
  var hasShown = false;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
  }

  function showPopup() {
    if (hasShown || getCookie(COOKIE_NAME)) return;
    hasShown = true;
    overlay.classList.add('newsletter-popup-overlay--active');
    document.body.style.overflow = 'hidden';
  }

  function hidePopup() {
    overlay.classList.remove('newsletter-popup-overlay--active');
    document.body.style.overflow = '';
    setCookie(COOKIE_NAME, '1', DISMISS_DAYS);
  }

  function onScroll() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight <= 0) return;
    if (scrollTop / docHeight >= SCROLL_TRIGGER_PERCENT) {
      showPopup();
      window.removeEventListener('scroll', onScroll);
    }
  }

  if (!getCookie(COOKIE_NAME)) {
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  overlay.querySelector('.newsletter-popup__close').addEventListener('click', hidePopup);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) hidePopup();
  });

  // If they submit and reload with a success message, close cookie so it doesn't reappear
  if (overlay.querySelector('.newsletter-popup__success')) {
    setCookie(COOKIE_NAME, '1', 365);
  }
})();